// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sbartags.mod-dragged-tag-has-children .sbartag.mod-is-children>.sbartag-marker-sort::after{opacity:0}.sbartags.mod-dragged-tag-has-children .sbartag>.sbartag-marker-nest{display:none}\n", ""]);
// Exports
module.exports = exports;
